import './AdvertiserShowComponent.css';

import { observer }                              from 'mobx-react';
import { Popconfirm }                            from 'antd';
import { Button }                                from 'antd';
import { EditOutlined }                          from '@ant-design/icons';
import { QuestionCircleOutlined }                from '@ant-design/icons';
import { DeleteOutlined }                        from '@ant-design/icons';
import { ApiCollection }                         from 'collections/ApiCollection';
import AdvertiserModel                           from 'models/AdvertiserModel';
import AdvertiserShowModel                       from 'models/AdvertiserShowModel';
import { AppForm }                               from 'components/App/AppForm';
import AdvertiserShowForm                        from 'forms/AdvertiserShowForm';
import { getAdvertiserAndAdvertiserShowMixData } from 'utils/advertiserProviderTool';
import FormattedMessageWrapper                   from 'components/App/FormattedMessageWrapper';

const AdvertiserShowComponent = ({
  advertiserCollection,
  advertiserShow,
  deleteAdvertiserShow,
  displayRightComponent = true,
  onSuccess = () => {
    // nothing
  },
  withClicks = true,
}: {
  advertiserCollection: ApiCollection<AdvertiserModel>;
  advertiserShow: AdvertiserShowModel;
  deleteAdvertiserShow?: (advertiserShow: AdvertiserShowModel) => void;
  displayRightComponent?: boolean;
  onSuccess?: () => void;
  withClicks?: boolean;
}) => {
  const advertiserFound = advertiserCollection.find(
    (advertiser: AdvertiserModel) => advertiser.get('@id') === advertiserShow.get('advertiser'),
  ) as AdvertiserModel;

  if (!advertiserFound) {
    return null;
  }

  const { link, linkFull, wording } = getAdvertiserAndAdvertiserShowMixData(
    advertiserFound,
    advertiserShow,
  );

  return (
    <div
      className="AdvertiserShowComponent__advertiser"
      key={advertiserShow.id}
    >
      <div
        className="AdvertiserShowComponent__advertiserInfos"
        style={{ flex: 1 }}
      >
        {!!advertiserFound && (
          <div>
            <strong>{wording}</strong>
            <br />
            <a
              href={linkFull}
              key={advertiserShow.get('@id')}
              onClick={() => {
                if (!withClicks) {
                  advertiserShow.patch({ clicked: true });
                }
              }}
              rel="noreferrer"
              style={{
                lineBreak: 'anywhere',
                wordWrap: 'break-word',
              }}
              target="_blank"
            >
              {link}
            </a>
            <br />
            {advertiserShow.counter} <FormattedMessageWrapper id="clics" />
          </div>
        )}
      </div>

      {displayRightComponent && (
        <div className="AdvertiserShowComponent__advertiserActions">
          <Button
            htmlType="button"
            icon={<EditOutlined />}
            onClick={event => {
              event.stopPropagation();
              AppForm.open(AdvertiserShowForm, {
                advertiserCollection,
                model: advertiserShow,
                onSuccess,
              }, {
                title: <FormattedMessageWrapper id="Modifier l'annonce" />,
              });
            }}
          />

          <Popconfirm
            cancelText={<FormattedMessageWrapper id="Non" />}
            icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
            okText={<FormattedMessageWrapper id="Oui" />}
            onCancel={event => event?.stopPropagation()}
            onConfirm={event => {
              event?.stopPropagation();
              if (deleteAdvertiserShow) {
                deleteAdvertiserShow(advertiserShow);
              }
            }}
            placement="left"
            title={
              <FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer cette annonce ?" />
            }
          >
            <Button
              htmlType="button"
              icon={<DeleteOutlined />}
              onClick={event => {
                event.stopPropagation();
              }}
            />
          </Popconfirm>
        </div>
      )}

    </div>
  );
};

const AdvertiserShowComponentObserver = observer(AdvertiserShowComponent);

export default AdvertiserShowComponentObserver;
